import { schemes, zSchema } from "@zeal/common";

const browserFileSchema =
  typeof File === "undefined" ? zSchema.any() : zSchema.instanceof(File);

export const updatePartnerQuestionnaireRequestSchema = zSchema.object({
  partner_id: schemes.uuid(),
  business_model_description: zSchema.string().max(255),
  expected_volume_and_scale: zSchema.string().max(255),
  payment_and_funds_flow_description: zSchema.string().max(255),
  sensitive_data_handling: zSchema.string().max(255),
  questionnaire_attestation: zSchema.boolean(),
  security_documents: zSchema.array(browserFileSchema).optional(),
});

export type TUpdatePartnerQuestionnaireRequestSchema = zSchema.infer<
  typeof updatePartnerQuestionnaireRequestSchema
>;

export const updatePartnerQuestionnaireResponseSchema = zSchema.object({
  white_label_id: zSchema.string(),
  business_model_description: zSchema.string(),
  expected_volume_and_scale: zSchema.string(),
  payment_and_funds_flow_description: zSchema.string(),
  sensitive_data_handling: zSchema.string(),
  questionnaire_attestation: zSchema.boolean(),
});

export type TUpdatePartnerQuestionnaireResponseSchema = zSchema.infer<
  typeof updatePartnerQuestionnaireResponseSchema
>;
